import axios from "axios";
import { HTTP_RESPONSE_CODES } from "../constant";

const api = axios.create({
    baseURL: '/',
    headers: {
        'Content-Type': 'application/json'
    }
})

const ACCESS_TOKEN_NAME = 'ACCESS_TOKEN';

api.interceptors.request.use(config => {
    const token = localStorage.getItem(ACCESS_TOKEN_NAME)
    if (token) {
        config.headers['Authorization'] = token
    }
    return config
}, err => Promise.reject(err))

api.interceptors.response.use(response => response, (err) => {
    if (err?.response && err?.response?.status === HTTP_RESPONSE_CODES.UNAUTHORIZED) {
        localStorage.clear();
        window.location.href = '/'
    }
    return Promise.reject(err);

})

export default api;